module.exports = __webpack_public_path__ + "img/lovecow.0e1152ef.jpg";